(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditAssignmentTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditAssignmentTabView.html",
            controller: ["learningItemAssignmentLocalizationResource", "learningItemAssignmentResource", "FILE_FORMATS", "messageService", "$scope", "$timeout", "Upload", "$uibModal", "_", LearningItemEditAssignmentTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditAssignmentTabCtrl(learningItemAssignmentLocalizationResource, learningItemAssignmentResource, FILE_FORMATS, messageService, $scope, $timeout, Upload, $uibModal, _) {
            var vm = this;
            vm.maxAllowedFiles = 1;
            vm.acceptedFiles = FILE_FORMATS.assignment;
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
            }).catch(angular.noop);
            vm.getAssignment = function (id) {
                return _.find(vm.learningItem.learningItemAssignmentLocalizations, { localizationId: id });
            };
            vm.viewInstructions = function (assignment) {
                $uibModal.open({
                    templateUrl: "instructions.html",
                    controller: ["assignment", function (assignment) {
                            var vm = this;
                            vm.assignment = assignment;
                        }],
                    controllerAs: "vm",
                    animation: false,
                    resolve: {
                        assignment: assignment
                    }
                }).result.catch(angular.noop);
            };
            vm.removeTemplate = function (assignment) {
                vm.removing = true;
                var modal = $uibModal.open({
                    templateUrl: "deleteFileConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    learningItemAssignmentLocalizationResource.removeTemplate({ id: assignment.id, localizationId: assignment.localizationId }, function () {
                        assignment.fileName = null;
                        assignment.fileUrl = null;
                        vm.removing = false;
                    }, function (error) {
                        vm.removing = false;
                        messageService.error(error);
                    });
                }, function () {
                    vm.removing = false;
                });
            };
            vm.uploadTemplate = function (file, assignment) {
                vm.localizationId = assignment.localizationId;
                if (file) {
                    var url = "api/learningItemAssignmentLocalization/" + assignment.id + "/" + assignment.localizationId + "/uploadTemplate";
                    file.upload = Upload.upload({
                        url: url,
                        data: {
                            file: file
                        }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            assignment.fileName = file.name;
                            assignment.fileUrl = response.data.value;
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.progress = 0;
                        });
                    }, function (response) {
                        messageService.error(response);
                        vm.progress = 0;
                    }, function (evt) {
                        vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.addOrEditAssignment = function (edit, localization, assignment) {
                vm.editing = true;
                var modal = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemType/learningItemEditAssignmentModalView.html",
                    controller: "LearningItemEditAssignmentModalCtrl as vm",
                    size: "lg",
                    backdrop: "static",
                    resolve: {
                        data: {
                            localizationId: localization,
                            learningItemId: vm.learningItem.id,
                            assignment: angular.copy(assignment)
                        }
                    }
                });
                modal.result.then(function (result) {
                    if (result) {
                        if (edit)
                            _.extend(_.find(vm.learningItem.learningItemAssignmentLocalizations, { id: result.id }), result);
                        else
                            vm.learningItem.learningItemAssignmentLocalizations.push(result);
                        vm.learningItem.enabledLocalizations = angular.copy(vm.learningItem.enabledLocalizations);
                    }
                    vm.editing = false;
                }, function () {
                    vm.editing = false;
                });
            };
            vm.editScore = function () {
                vm.saving = true;
                var modal = $uibModal.open({
                    templateUrl: "editScore.html",
                    backdrop: false,
                    animation: false,
                    controller: ["data", "$scope", function (data, $scope) {
                            var vm = this;
                            vm.passingScore = data.passingScore;
                            vm.updateScore = function () {
                                if (!vm.form.$valid || vm.saving) {
                                    vm.showErrors = true;
                                    return;
                                }
                                vm.updading = true;
                                var model = { learningItemId: data.learningItemId, passingScore: vm.passingScore };
                                learningItemAssignmentResource.updateScore({ id: data.learningItemId }, model, function () {
                                    messageService.success("common.changesSaved");
                                    vm.updading = false;
                                    $scope.$close(vm.passingScore);
                                }, function (error) {
                                    messageService.error(error);
                                    vm.updading = false;
                                });
                            };
                        }],
                    controllerAs: "vm",
                    resolve: {
                        data: {
                            passingScore: vm.learningItem.learningItemAssignmentDetails.passingScore,
                            learningItemId: vm.learningItem.id
                        }
                    }
                });
                modal.result.then(function (score) {
                    if (score)
                        vm.learningItem.learningItemAssignmentDetails.passingScore = score;
                }).catch(angular.noop);
            };
        }
    });
})();
